import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdNavigateNext } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import SiteMapAPI from "../api/SiteMapAPI";
import useSitePanel from "../store/useSitePanel";

function ListMenu(className) {
  const style = className.className;
  // const menuItems = useMenuItems((state) => state.menuItems);
  const [menuItems, setMenuItems] = useState([]);
  const statusButton = useSitePanel((state) => state.status);
  const toggleButton = useSitePanel((state) => state.toggle);
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const pathname = location.pathname;
  const navigate = useNavigate();

  const [megaMenu, setMegaMenu] = useState(false);
  const [subMenuItems, setSubMenuItems] = useState([]);

  const getMenus = useCallback(() => {
    (i18n.language === "en"
      ? SiteMapAPI.getSiteMapEn()
      : SiteMapAPI.getSiteMap()
    )
      .then((res) => {
        const menus = res.data[0].Navigation;

        const mapMenu = menus
          .filter((mn) => mn.active)
          .map((menu) => {
            return {
              text: menu.title,
              to: menu.url,
              type: menu.type,
              hoverStatus: menu?.children?.length > 0,
              target: menu?.target,
              submenu: menu?.children
                .filter((mn) => mn.active)
                ?.map((submenu) => {
                  return {
                    text: submenu.title,
                    to: submenu.url,
                    type: submenu.type,
                    target: submenu?.target,
                    colIndex: submenu?.data?.column ?? 0,
                    submenu: submenu?.children
                      .filter((mn) => mn.active)
                      ?.map((sub) => {
                        return {
                          text: sub.title,
                          to: sub.url,
                          type: sub.type,
                          target: sub?.target,
                          colIndex: sub?.data?.column ?? 0,
                        };
                      }),
                  };
                }),
            };
          });

        setMenuItems(mapMenu);
      })
      .catch((err) => console.log(err));
  }, [setMenuItems]);

  console.log("menuItems", menuItems);

  useEffect(() => {
    getMenus();
  }, [getMenus]);

  const megaMenuHover = (status, submenu) => {
    megaMenuHoverOut();

    if (status) {
      // console.log('Megamenu hover', submenu);
      setMegaMenu(true);
      setSubMenuItems(submenu.filter((sub) => !sub?.isNotShowMenu));
    }
  };
  const megaMenuHoverOut = () => {
    console.log("Megamenu hover out");
    setMegaMenu(false);
    setSubMenuItems([]);
  };

  const namePath = (data) => {
    const basePath = data.split("/").slice(0, 2).join("");
    return basePath;
  };

  const [submenuSecond, setSubmenuSecond] = useState(false);
  const [indexSecond, setIndexSecond] = useState(0);
  const toggleDropdownSecond = (value, index) => {
    setSubmenuSecond(!value);
    setIndexSecond(index);
  };

  const [submenuThird, setSubmenuThird] = useState(false);
  const [indexThird, setIndexThird] = useState(0);
  const toggleDropdownThird = (value, index) => {
    setSubmenuThird(!value);
    setIndexThird(index);
  };

  const DropdownMenu = ({ subMenus }) => {
    return (
      <ul
        className="z-[999]"
        // className={subMenuItems.length > 3 ? "columns-2" : "columns-1"}
      >
        {subMenus.map((item, index) => {
          return (
            <li
              key={index}
              className={`${
                pathname === item.to ? "underline" : ""
              } menu-item ${item.to === "#" ? "disabled" : ""}`}
            >
              <span
                onClick={() => {
                  if (item.target === "_blank") {
                    window.open(item.to, "_blank");
                  } else {
                    navigate(item.to);
                  }

                  megaMenuHoverOut();
                }}
              >
                {item.text}
              </span>
              {item.submenu.length > 0 && (
                <ul className="ml-4 text-white text-md mt-4">
                  {item.submenu.map((el, i) => (
                    <li
                      key={i}
                      className={`${
                        pathname === el.to ? "underline" : ""
                      } py-2 hover:opacity-55 cursor-pointer`}
                    >
                      <span
                        onClick={() => {
                          if (el.target === "_blank") {
                            window.open(el.to, "_blank");
                          } else {
                            navigate(el.to);
                          }

                          megaMenuHoverOut();
                        }}
                      >
                        {el.text}
                      </span>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <>
      <nav className={style}>
        {menuItems.map((item, index) => (
          <li
            key={index}
            className="menu-item"
            onMouseEnter={() => megaMenuHover(item.hoverStatus, item.submenu)}
          >
            <div
              className={`${
                pathname === item.to || namePath(pathname) === item.type
                  ? "active"
                  : ""
              } w-full relative`}
            >
              <span
                onClick={() => {
                  if (item.target === "_blank") {
                    window.open(item.to, "_blank");
                  } else {
                    navigate(item.to);
                  }

                  megaMenuHoverOut();
                }}
                // to={item.to}
                className="menu-item__first"
              >
                {t(item.text)}
              </span>
              {item.hoverStatus && (
                <div
                  onClick={() => toggleDropdownSecond(submenuSecond, index)}
                  className={`button-icon-dropdown transition-all ${
                    submenuSecond && indexSecond === index ? "rotate-90" : ""
                  }`}
                >
                  <MdNavigateNext />
                </div>
              )}
              {submenuSecond && (
                <div className="menu-item__submenu">
                  <ul>
                    {item.submenu.map((el, i) => (
                      <li key={i} className="w-full relative">
                        <span
                          onClick={() => {
                            if (el.target === "_blank") {
                              window.open(el.to, "_blank");
                            } else {
                              navigate(el.to);
                            }

                            megaMenuHoverOut();
                          }}
                          // to={el.to}
                          className="menu-item__second"
                        >
                          {el.text}
                        </span>
                        {el.submenu.length > 0 && (
                          <div
                            onClick={() => toggleDropdownThird(submenuThird, i)}
                            className={`button-icon-dropdown transition-all ${
                              submenuThird && indexThird === i
                                ? "rotate-90"
                                : ""
                            }`}
                          >
                            <MdNavigateNext />
                          </div>
                        )}
                        {submenuThird && (
                          <ul>
                            {el.submenu.map((list, ilist) => (
                              <li key={ilist} className="w-full">
                                <span
                                  // to={list.to}
                                  onClick={() => {
                                    if (list.target === "_blank") {
                                      window.open(list.to, "_blank");
                                    } else {
                                      navigate(list.to);
                                    }

                                    toggleButton();
                                  }}
                                  // to={list.to}
                                  className="menu-item__third"
                                >
                                  {list.text}
                                </span>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </li>
        ))}
      </nav>
      <div
        className={`${
          megaMenu || statusButton ? "h-0 md:h-auto" : "h-0"
        } mega-menu-panel overflow-y-auto max-h-[calc(100vh-100px)] z-[999]`}
        onMouseLeave={megaMenuHoverOut}
      >
        <div
          className={`grid grid-cols-${
            Math.max(...subMenuItems.map((me) => me.colIndex)) + 1
          } z-[999]`}
        >
          <DropdownMenu
            subMenus={subMenuItems.filter((me) => me.colIndex === 0)}
          />
          <DropdownMenu
            subMenus={subMenuItems.filter((me) => me.colIndex === 1)}
          />
        </div>
        {/* <ul
          className={subMenuItems.length > 3 ? "columns-2" : "columns-1"}
          onMouseLeave={megaMenuHoverOut}
        >
          {subMenuItems.map((item, index) => {
            return (
              <li
                key={index}
                className={`${
                  pathname === item.to ? "underline" : ""
                } menu-item ${item.to === "#" ? "disabled" : ""}`}
              >
                <Link to={item.to} onClick={() => megaMenuHoverOut()}>
                  {item.text}
                </Link>
                {item.submenu.length > 0 && (
                  <ul className="ml-4 text-white text-md mt-4">
                    {item.submenu.map((el, i) => (
                      <li
                        key={i}
                        onClick={() => {
                          navigate(el.to);
                          megaMenuHoverOut();
                        }}
                        className={`${
                          pathname === el.to ? "underline" : ""
                        } py-2 hover:opacity-55 cursor-pointer`}
                      >
                        <Link
                        // to={el.to}
                        >
                          {el.text}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            );
          })}
        </ul> */}
      </div>
    </>
  );
}

export default ListMenu;
